import axios from 'axios';
import { UiContainer } from '../../state/ui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../i18n/i18n';
import { useEffect } from 'react';

export function NetworkErrorHandling() {
	const ui = UiContainer.useContainer();
	const history = useHistory();
	const urls = useTranslation().routes;

	useEffect(() => {
		const interceptor = axios.interceptors.response.use(
			(res) => res,
			(error) => {
				if (error.response) {
					switch (error.response.status) {
						case 401:
							const { method, url, withCredentials, data } = error.response.config;
							const request = { method, url, withCredentials, data };
							const { pathname: previousLocation } = history.location;
							history.push({
								pathname: urls.login,
								state: { request, previousLocation },
							});
							ui.showLoginModal(true);
							break;
					}
					return Promise.reject(error);
				}
				return error;
			}
		);

		return () => {
			axios.interceptors.response.eject(interceptor);
		};
	}, [ui, history, urls]);

	return null;
}
